import { render, staticRenderFns } from "./useAI.vue?vue&type=template&id=83bff532&scoped=true"
import script from "./useAI.vue?vue&type=script&lang=js"
export * from "./useAI.vue?vue&type=script&lang=js"
import style0 from "./useAI.vue?vue&type=style&index=0&id=83bff532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bff532",
  null
  
)

export default component.exports